import React, { Component } from 'react'

export class HomePage extends Component {
    render() {
        return (
            <div>
                <h1>Welcome</h1>
                Welcome to CHRGIS data downloads!
                {/* <RequestList></RequestList> */}
            </div>
        )
    }
}

export default HomePage
